module.exports = __webpack_public_path__ + "img/archive.5a219bcf.svg";